// extracted by mini-css-extract-plugin
module.exports = {"video":"room_video__1HO7s","videoFull":"room_videoFull__M9Yha","chat":"room_chat__o0TwB","disableEl":"room_disableEl__1tIG5"};